import React from 'react';
import logo from './logo.svg';
import {Routes, Route, Navigate} from "react-router-dom";
import './App.css';
import {BrowserRouter} from "react-router-dom";
import {LoginScreen} from "./components/login/LoginScreen";
import store from "./store/Store";
import {Provider} from "react-redux";
import {HomeRedirect} from "./components/home/HomeRedirect";
import {ClientsScreen} from "./components/clients/ClientsScreen";
import {NewClientScreen} from "./components/clients/NewClientScreen";
import {CategoryTypesScreen} from "./components/categoryTypes/CategoryTypesScreen";
import {NewCategoryTypeScreen} from "./components/categoryTypes/NewCategoryTypeScreen";
import {ModifyCategoryTypeScreen} from "./components/categoryTypes/ModifyCategoryTypeScreen";
import {DeleteCategoryTypeScreen} from "./components/categoryTypes/DeleteCategoryTypeScreen";
import {CategoriesScreen} from "./components/categories/CategoriesScreen";
import {NewCategoryScreen} from "./components/categories/NewCategoryScreen";
import {ModifyCategoryScreen} from "./components/categories/ModifyCategoryScreen";
import {DeleteCategoryScreen} from "./components/categories/DeleteCategoryScreen";
import {ServicesScreen} from "./components/services/ServicesScreen";
import {NewServiceScreen} from "./components/services/NewServiceScreen";
import {ModifyServiceScreen} from "./components/services/ModifyServiceScreen";
import {DeleteServiceScreen} from "./components/services/DeleteServiceScreen";
import {ModifyClientScreen} from "./components/clients/ModifyClientScreen";
import {DeleteClientScreen} from "./components/clients/DeleteClientScreen";
import {ClientContactsScreen} from "./components/clientContacts/ClientContactsScreen";
import {NewClientContactScreen} from "./components/clientContacts/NewClientContactScreen";
import {ModifyClientContactScreen} from "./components/clientContacts/ModifyClientContactScreen";
import {DeleteClientContactScreen} from "./components/clientContacts/DeleteClientContactScreen";
import {VendorsScreen} from "./components/vendors/VendorsScreen";
import {NewVendorScreen} from "./components/vendors/NewVendorScreen";
import {ModifyVendorScreen} from "./components/vendors/ModifyVendorScreen";
import {DeleteVendorScreen} from "./components/vendors/DeleteVendorScreen";
import {VendorContactsScreen} from "./components/vendorContacts/VendorContactsScreen";
import {NewVendorContactScreen} from "./components/vendorContacts/NewVendorContactScreen";
import {ModifyVendorContactScreen} from "./components/vendorContacts/ModifyVendorContactScreen";
import {DeleteVendorContactScreen} from "./components/vendorContacts/DeleteVendorContactScreen";
import {UsersScreen} from "./components/users/UsersScreen";
import {NewUserScreen} from "./components/users/NewUserScreen";
import {ModifyUserScreen} from "./components/users/ModifyUserScreen";
import {DeleteUserScreen} from "./components/users/DeleteUserScreen";
import {OfflineReasonsScreen} from "./components/offlineReasons/OfflineReasonsScreen";
import {NewOfflineReasonScreen} from "./components/offlineReasons/NewOfflineReasonScreen";
import {ModifyOfflineReasonScreen} from "./components/offlineReasons/ModifyOfflineReasonScreen";
import {DeleteOfflineReasonScreen} from "./components/offlineReasons/DeleteOfflineReasonScreen";
import {ExtensionsScreen} from "./components/extensions/ExtensionsScreen";
import {NewExtensionScreen} from "./components/extensions/NewExtensionScreen";
import {ModifyExtensionScreen} from "./components/extensions/ModifyExtensionScreen";
import {DeleteExtensionScreen} from "./components/extensions/DeleteExtensionScreen";
import {InquiriesScreen} from "./components/inquiry/InquiriesScreen";
import {NewInquiryScreen} from "./components/inquiry/NewInquiryScreen";
import {ModifyInquiryScreen} from "./components/inquiry/ModifyInquiryScreen";
import {DeleteInquiryScreen} from "./components/inquiry/DeleteInquiryScreen";
import {MarkAnsweredScreen} from "./components/inquiry/MarkAnsweredScreen";
import {ArchiveInquiryScreen} from "./components/inquiry/ArchiveInquiryScreen";
import {NewOrderScreen} from "./components/orders/NewOrderScreen";
import {ModifyOrderScreen} from "./components/orders/ModifyOrderScreen";
import {OrdersScreen} from "./components/orders/OrdersScreen";
import {DeleteOrderScreen} from "./components/orders/DeleteOrderScreen";
import {SendEmailStep1} from "./components/sendEmail/SendEmailStep1";
import {SendEmailStep2} from "./components/sendEmail/SendEmailStep2";
import {SendEmailStep3} from "./components/sendEmail/SendEmailStep3";
import SendSMSStep1 from "./components/sendSms/SendSMSStep1";
import {SendSMSStep2} from "./components/sendSms/SensSMSStep2";
import {SendSMSStep3} from "./components/sendSms/SendSMSStep3";
import {EmailsScreen} from "./components/emails/EmailsScreen";
import {SMSSendersScreen} from "./components/smsSenders/SMSSendersScreen";
import {NewSMSSenderScreen} from "./components/smsSenders/NewSMSSenderScreen";
import {ModifySMSSenderScreen} from "./components/smsSenders/ModifySMSSenderScreen";
import {DeleteSMSSenderScreen} from "./components/smsSenders/DeleteSMSSenderScreen";
import {TopClientsScreen} from "./components/topClients/TopClientsScreen";
import {NewInsuranceRateScreen} from "./components/insuranceRates/NewInsuranceRateScreen";
import {ModifyInsuranceRateScreen} from "./components/insuranceRates/ModifyInsuranceRateScreen";
import {DeleteInsuranceRateScreen} from "./components/insuranceRates/DeleteInsuranceRateScreen";
import {InsuranceRatesScreen} from "./components/insuranceRates/InsuranceRatesScreen";
import {CheckerScreen} from "./components/checker/CheckerScreen";
import {SettingsScreen} from "./components/settings/SettingsScreen";
import {ServiceEmailsScreen} from "./components/services/ServiceEmailsScreen";
import {UserStatusScreen} from "./components/userStatus/UserStatusScreen";
import {StatusResultsScreen} from "./components/results/StatusResultsScreen";
import {AmountResultsScreen} from "./components/results/AmountResultsScreen";
import {ProfitResultsScreen} from "./components/results/ProfitResultsScreen";
import {UserStatusResultsScreen} from "./components/results/UserStatusResultsScreen";
import {InvoiceOrderScreen} from "./components/orders/InvoiceOrderScreen";
import {MarkUnansweredScreen} from "./components/inquiry/MarkUnansweredScreen";
import {MyResultsScreen} from "./components/results/MyResultsScreen";
import {DlogScreen} from "./components/dlog/DLogScreen";
import {RecommendedVendorsScreen} from "./components/inquiry/RecommendedVendorsScreen";
import {LoadingsScreen} from "./components/clients/LoadingsScreen";
import UnpaidLock from "./components/locks/UnpaidLock";
import {RecommendedVendorsEmailScreen} from "./components/inquiry/RecommendedVendorsEmailScreen";
import {RateOrderScreen} from "./components/orders/RateOrderScreen";
import {VendorContactsRatingsScreen} from "./components/vendorContacts/VendorContactRatingsScreen";
import {ModifyLoadingScreen} from "./components/loadings/ModifyLoadingScreen";
import {DeleteLoadingScreen} from "./components/loadings/DeleteLoadingScreen";
import {PerformanceIndicatorsScreen} from "./components/performanceIndicators/PerformanceIndicatorsScreen";
import {AdvertisingSettingsScreen} from "./components/advertisingSettings/AdvertisingSettingsScreen";
import {SystemSettingsScreen} from "./components/systemSettings/SystemSettingsScreen";

function App() {
    return (
        <Provider store={store}>
            <BrowserRouter>
                <div className="App" id="wrapper">
                    <Routes>
                        <Route path="/" element={<HomeRedirect/>}/>
                        <Route path="login" element={<LoginScreen/>}/>

                        <Route path="clients" element={<ClientsScreen/>}/>
                        <Route path="clients/new" element={<NewClientScreen/>}/>
                        <Route path="clients/:id/modify" element={<ModifyClientScreen/>}/>
                        <Route path="clients/:id/delete" element={<DeleteClientScreen/>}/>
                        <Route path="clients/:id/loadings" element={<LoadingsScreen/>}/>
                        <Route path="clients/:clientId/loadings/:loadingId/modify" element={<ModifyLoadingScreen/>}/>
                        <Route path="clients/:clientId/loadings/:loadingId/delete" element={<DeleteLoadingScreen/>}/>

                        <Route path="clients/:clientId/contacts" element={<ClientContactsScreen/>}/>
                        <Route path="clients/:clientId/contacts/new" element={<NewClientContactScreen/>}/>
                        <Route path="clients/:clientId/contacts/:contactId/modify" element={<ModifyClientContactScreen/>}/>
                        <Route path="clients/:clientId/contacts/:contactId/delete" element={<DeleteClientContactScreen/>}/>

                        <Route path="vendors" element={<VendorsScreen/>}/>
                        <Route path="vendors/new" element={<NewVendorScreen/>}/>
                        <Route path="vendors/:id/modify" element={<ModifyVendorScreen/>}/>
                        <Route path="vendors/:id/delete" element={<DeleteVendorScreen/>}/>

                        <Route path="vendors/:vendorId/contacts" element={<VendorContactsScreen/>}/>
                        <Route path="vendors/:vendorId/contacts/new" element={<NewVendorContactScreen/>}/>
                        <Route path="vendors/:vendorId/contacts/:contactId/modify" element={<ModifyVendorContactScreen/>}/>
                        <Route path="vendors/:vendorId/contacts/:contactId/delete" element={<DeleteVendorContactScreen/>}/>
                        <Route path="vendors/:vendorId/contacts/:contactId/ratings" element={<VendorContactsRatingsScreen/>}/>

                        <Route path="category-types" element={<CategoryTypesScreen/>}/>
                        <Route path="category-types/new" element={<NewCategoryTypeScreen/>}/>
                        <Route path="category-types/:id/modify" element={<ModifyCategoryTypeScreen/>}/>
                        <Route path="category-types/:id/delete" element={<DeleteCategoryTypeScreen/>}/>

                        <Route path="categories" element={<CategoriesScreen/>}/>
                        <Route path="categories/new" element={<NewCategoryScreen/>}/>
                        <Route path="categories/:id/modify" element={<ModifyCategoryScreen/>}/>
                        <Route path="categories/:id/delete" element={<DeleteCategoryScreen/>}/>

                        <Route path="services" element={<ServicesScreen/>}/>
                        <Route path="services/new" element={<NewServiceScreen/>}/>
                        <Route path="services/:id/modify" element={<ModifyServiceScreen/>}/>
                        <Route path="services/:id/delete" element={<DeleteServiceScreen/>}/>
                        <Route path="services/:id/emails" element={<ServiceEmailsScreen/>}/>

                        <Route path="users" element={<UsersScreen/>}/>
                        <Route path="users/new" element={<NewUserScreen/>}/>
                        <Route path="users/:id/modify" element={<ModifyUserScreen/>}/>
                        <Route path="users/:id/delete" element={<DeleteUserScreen/>}/>

                        <Route path="offline-reasons" element={<OfflineReasonsScreen/>}/>
                        <Route path="offline-reasons/new" element={<NewOfflineReasonScreen/>}/>
                        <Route path="offline-reasons/:id/modify" element={<ModifyOfflineReasonScreen/>}/>
                        <Route path="offline-reasons/:id/delete" element={<DeleteOfflineReasonScreen/>}/>

                        <Route path="extensions" element={<ExtensionsScreen/>}/>
                        <Route path="extensions/new" element={<NewExtensionScreen/>}/>
                        <Route path="extensions/:id/modify" element={<ModifyExtensionScreen/>}/>
                        <Route path="extensions/:id/delete" element={<DeleteExtensionScreen/>}/>

                        <Route path="inquiries" element={<InquiriesScreen/>}/>
                        <Route path="inquiries/new" element={<NewInquiryScreen/>}/>
                        <Route path="inquiries/:id/modify" element={<ModifyInquiryScreen/>}/>
                        <Route path="inquiries/:id/delete" element={<DeleteInquiryScreen/>}/>
                        <Route path="inquiries/:id/mark-answered" element={<MarkAnsweredScreen/>}/>
                        <Route path="inquiries/:id/mark-unanswered" element={<MarkUnansweredScreen/>}/>
                        <Route path="inquiries/:id/archive" element={<ArchiveInquiryScreen/>}/>
                        <Route path="inquiries/:id/recommended" element={<RecommendedVendorsScreen/>}/>
                        <Route path="inquiries/:id/recommended/send" element={<RecommendedVendorsEmailScreen/>}/>

                        <Route path="orders" element={<OrdersScreen/>}/>
                        <Route path="orders/new/:id/:type" element={<NewOrderScreen/>}/>
                        <Route path="orders/:id/modify" element={<ModifyOrderScreen />}/>
                        <Route path="orders/:id/delete" element={<DeleteOrderScreen />}/>
                        <Route path="orders/:id/invoice" element={<InvoiceOrderScreen />}/>
                        <Route path="orders/:id/rate" element={<RateOrderScreen />}/>

                        <Route path="send-email" element={<SendEmailStep1/>}/>
                        <Route path="send-email/2" element={<SendEmailStep2/>}/>
                        <Route path="send-email/3" element={<SendEmailStep3 />}/>

                        <Route path="send-sms" element={<SendSMSStep1/>}/>
                        <Route path="send-sms/2" element={<SendSMSStep2/>}/>
                        <Route path="send-sms/3" element={<SendSMSStep3 />}/>

                        <Route path="emails" element={<EmailsScreen/>}/>

                        <Route path="sms-senders" element={<SMSSendersScreen/>}/>
                        <Route path="sms-senders/new" element={<NewSMSSenderScreen/>}/>
                        <Route path="sms-senders/:id/modify" element={<ModifySMSSenderScreen/>}/>
                        <Route path="sms-senders/:id/delete" element={<DeleteSMSSenderScreen/>}/>

                        <Route path="top-clients" element={<TopClientsScreen/>}/>

                        <Route path="insurance" element={<InsuranceRatesScreen />}/>
                        <Route path="insurance/new" element={<NewInsuranceRateScreen/>}/>
                        <Route path="insurance/:id/modify" element={<ModifyInsuranceRateScreen/>}/>
                        <Route path="insurance/:id/delete" element={<DeleteInsuranceRateScreen/>}/>

                        <Route path="checker/loadings" element={<CheckerScreen type={'loadings'} />}/>
                        <Route path="checker/unloadings" element={<CheckerScreen type={'unloadings'} />}/>

                        <Route path="settings" element={<SettingsScreen />}/>

                        <Route path="user-status" element={<UserStatusScreen />}/>

                        <Route path="results/me" element={<MyResultsScreen />}/>
                        <Route path="results/status" element={<StatusResultsScreen />}/>
                        <Route path="results/status/:id" element={<UserStatusResultsScreen />}/>
                        <Route path="results/amount" element={<AmountResultsScreen />}/>
                        <Route path="results/profit" element={<ProfitResultsScreen />}/>
                        <Route path="results/performance" element={<PerformanceIndicatorsScreen />}/>

                        <Route path="lock/unpaid" element={<UnpaidLock />}/>

                        <Route path="advertising" element={<AdvertisingSettingsScreen />}/>

                        <Route path="system" element={<SystemSettingsScreen />}/>

                    </Routes>
                </div>
            </BrowserRouter>
        </Provider>
    );
}

export default App;
